import React, { FunctionComponent } from 'react';
import { ReactComponent as BingoJackpot } from '../../../../assets/Itv/jackpot-icon.svg';

export const BingoJackpotIcon: FunctionComponent<React.ComponentPropsWithoutRef<'svg'>> = (props): JSX.Element => (
  <BingoJackpot {...props} />
);
